import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type HrisInstallService from 'garaje/services/hris-install';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';

export default class HrisDashboardRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare hrisInstall: HrisInstallService;
  @service declare router: RouterService;
  @service declare skinnyLocations: SkinnyLocationsService;

  titleToken = 'HRIS Dashboard';

  async beforeModel(): Promise<void> {
    if (!this.featureFlags.isEnabled('integration-hris-dashboard')) {
      return void this.router.transitionTo('unauthorized');
    }
    await this.hrisInstall.load();
    if (!this.hrisInstall.isInstalled) {
      return void this.router.transitionTo('unauthorized');
    }
    if (!this.abilities.can('visit hris-dashboard')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  async model(): Promise<{ locations: unknown[]; isGlobal: boolean; isReadOnly: boolean }> {
    await this.skinnyLocations.loadAllTask.perform();
    return {
      locations: this.skinnyLocations.currentCompanyLocations,
      isGlobal: false,
      isReadOnly: this.abilities.cannot('manage all hris-dashboard') && this.abilities.cannot('manage hris-dashboard'),
    };
  }
}
